import { render, staticRenderFns } from "./UniversityList.vue?vue&type=template&id=41597a03&scoped=true&"
import script from "./UniversityList.vue?vue&type=script&lang=js&"
export * from "./UniversityList.vue?vue&type=script&lang=js&"
import style0 from "./UniversityList.vue?vue&type=style&index=0&id=41597a03&lang=css&scoped=true&"
import style1 from "./UniversityList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41597a03",
  null
  
)

export default component.exports